(function () {
  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function initResourcesLibrary(scope) {
    const libraries = (scope || document).querySelectorAll('.resources-library-js');

    libraries.forEach((library) => {
      if (library.dataset.initialized === 'true') return;
      library.dataset.initialized = 'true';

      const list = library.querySelector('[data-resources-list]');
      const pagination = library.querySelector('[data-resources-pagination]');
      const pillsWrap = library.querySelector('[data-resources-category-pills]');
      const noResultsBox = library.querySelector('[data-resources-no-results]');

      if (!list || !pagination || !pillsWrap) return;

      const perPage = parseInt(library.dataset.perPage || '12', 10);
      const allItems = Array.from(list.querySelectorAll('[data-resource-item]'));

      if (!allItems.length) return;

      allItems.sort((a, b) => {
        const aOrder = parseInt(a.dataset.sortOrder || '9999', 10);
        const bOrder = parseInt(b.dataset.sortOrder || '9999', 10);

        if (aOrder !== bOrder) return aOrder - bOrder;

        const aTitle = a.dataset.title || '';
        const bTitle = b.dataset.title || '';
        return aTitle.localeCompare(bTitle);
      });

      allItems.forEach((item) => list.appendChild(item));

      const categoryMap = new Map();

      allItems.forEach((item) => {
        const rawCategory = String(item.dataset.category || '').trim();
        const normalizedCategory = normalizeValue(rawCategory);

        if (rawCategory && !categoryMap.has(normalizedCategory)) {
          categoryMap.set(normalizedCategory, rawCategory);
        }
      });

      Array.from(categoryMap.entries())
        .sort((a, b) => a[1].localeCompare(b[1]))
        .forEach(([value, label]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'resources-pill';
          button.setAttribute('data-category-pill', '');
          button.setAttribute('data-category-value', value);
          button.textContent = label;
          pillsWrap.appendChild(button);
        });

      let currentPage = 1;
      let activeCategory = 'all';

      function getFilteredItems() {
        if (activeCategory === 'all') return allItems;

        return allItems.filter((item) => {
          return normalizeValue(item.dataset.category) === activeCategory;
        });
      }

      function getQueryParams() {
        const url = new URL(window.location.href);
        return {
          page: parseInt(url.searchParams.get('resources_page') || '1', 10),
          category: normalizeValue(url.searchParams.get('resources_category') || 'all')
        };
      }

      function updateQueryParams(page, category) {
        const url = new URL(window.location.href);

        if (!page || page <= 1) {
          url.searchParams.delete('resources_page');
        } else {
          url.searchParams.set('resources_page', String(page));
        }

        if (!category || category === 'all') {
          url.searchParams.delete('resources_category');
        } else {
          url.searchParams.set('resources_category', category);
        }

        window.history.replaceState({}, '', url.toString());
      }

      function updatePillsState() {
        const pills = pillsWrap.querySelectorAll('[data-category-pill]');
        pills.forEach((pill) => {
          const value = normalizeValue(pill.dataset.categoryValue);
          pill.classList.toggle('is-active', value === activeCategory);
        });
      }

      function renderItems() {
        const filteredItems = getFilteredItems();
        const totalPages = Math.max(1, Math.ceil(filteredItems.length / perPage));
        currentPage = Math.min(Math.max(currentPage, 1), totalPages);

        const start = (currentPage - 1) * perPage;
        const end = start + perPage;

        allItems.forEach((item) => {
          item.classList.add('hidden');
        });

        filteredItems.forEach((item, index) => {
          if (index >= start && index < end) {
            item.classList.remove('hidden');
          }
        });

        if (noResultsBox) {
          if (filteredItems.length === 0) {
            noResultsBox.classList.remove('hidden');
          } else {
            noResultsBox.classList.add('hidden');
          }
        }

        updatePillsState();
        renderPagination(totalPages, filteredItems.length);
        updateQueryParams(currentPage, activeCategory);
      }

      function createButton(label, page, options) {
        const settings = options || {};
        const isCurrent = Boolean(settings.isCurrent);
        const isDisabled = Boolean(settings.isDisabled);
        const isEllipsis = Boolean(settings.isEllipsis);
        const isArrow = Boolean(settings.isArrow);

        const tag = isCurrent || isDisabled || isEllipsis ? 'span' : 'a';
        const element = document.createElement(tag);
        element.textContent = label;

        if (isArrow) {
          element.className = 'resources-pagination__arrow';
          if (isDisabled) element.classList.add('resources-pagination__arrow--disabled');
        } else {
          element.className = 'resources-pagination__item';
          if (isCurrent) element.classList.add('resources-pagination__item--current');
          if (isEllipsis) element.classList.add('resources-pagination__item--ellipsis');
        }

        if (tag === 'a') {
          const url = new URL(window.location.href);

          if (page <= 1) {
            url.searchParams.delete('resources_page');
          } else {
            url.searchParams.set('resources_page', String(page));
          }

          if (!activeCategory || activeCategory === 'all') {
            url.searchParams.delete('resources_category');
          } else {
            url.searchParams.set('resources_category', activeCategory);
          }

          element.href = url.toString();
          element.addEventListener('click', function (event) {
            event.preventDefault();
            currentPage = page;
            renderItems();
            scrollToLibrary();
          });
        }

        return element;
      }

      function getPaginationParts(totalPages) {
        const parts = [];
        const delta = 1;
        let prev = null;

        for (let i = 1; i <= totalPages; i++) {
          if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
            if (prev !== null && i - prev > 1) {
              parts.push('ellipsis');
            }
            parts.push(i);
            prev = i;
          }
        }

        return parts;
      }

      function renderPagination(totalPages, totalFilteredItems) {
        pagination.innerHTML = '';

        if (totalFilteredItems === 0 || totalPages <= 1) {
          pagination.classList.add('hidden');
          return;
        }

        pagination.classList.remove('hidden');

        const inner = document.createElement('div');
        inner.className = 'resources-pagination__inner';

        inner.appendChild(
          createButton('‹', currentPage - 1, {
            isArrow: true,
            isDisabled: currentPage === 1
          })
        );

        const pagesWrap = document.createElement('div');
        pagesWrap.className = 'resources-pagination__pages';

        getPaginationParts(totalPages).forEach((part) => {
          if (part === 'ellipsis') {
            pagesWrap.appendChild(createButton('…', null, { isEllipsis: true }));
          } else {
            pagesWrap.appendChild(
              createButton(String(part), part, {
                isCurrent: part === currentPage
              })
            );
          }
        });

        inner.appendChild(pagesWrap);

        inner.appendChild(
          createButton('›', currentPage + 1, {
            isArrow: true,
            isDisabled: currentPage === totalPages
          })
        );

        pagination.appendChild(inner);
      }

      function scrollToLibrary() {
        const section = library.closest('.resources-page');
        if (!section) return;

        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const top = rect.top + scrollTop - 120;

        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      }

      pillsWrap.addEventListener('click', function (event) {
        const pill = event.target.closest('[data-category-pill]');
        if (!pill) return;

        activeCategory = normalizeValue(pill.dataset.categoryValue || 'all');
        currentPage = 1;
        renderItems();
      });

      const queryParams = getQueryParams();

      if (!Number.isNaN(queryParams.page) && queryParams.page > 0) {
        currentPage = queryParams.page;
      }

      if (queryParams.category) {
        const exists = Array.from(pillsWrap.querySelectorAll('[data-category-pill]')).some((pill) => {
          return normalizeValue(pill.dataset.categoryValue) === queryParams.category;
        });

        if (exists) {
          activeCategory = queryParams.category;
        }
      }

      renderItems();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initResourcesLibrary(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initResourcesLibrary(event.target);
  });
})();